<template>
<div id="connect_service">
    <div class="partner-program">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <router-link to="#" onclick="return false;">Подключить автосервис</router-link>
                <router-link to="#" onclick="return false;">Поставщикам запчастей</router-link>
                <router-link to="#" onclick="return false;">Автомобильным сайтам</router-link>
                <h1>Партнёрские программы</h1>
            </div>
        </div>
    </div>
    <div class="application">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <div class="become-partner">Стать партнером «В-Автосервис» и получать еще больше клиентов очень просто.<br> Присоединяйтесь прямо сейчас!</div>
                <h2>Введите свои контактные данные, и мы свяжемся с вами!</h2>
                <div class="block clearfix">
                    <form action="" method="POST" id="application_partner">
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="name_service" placeholder="Название Автосервиса">
                            </div>
                        </div>
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="address_service" placeholder="Адрес Автосервиса">
                            </div>
                        </div>
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="site" placeholder="Сайт Автосервиса">
                            </div>
                        </div>
                        <div class="col-xs-120">
                            <div class="field">
                                <input type="text" name="specialization" placeholder="Специализация (например: слесарный и кузовной ремонт, мойка)">
                            </div>
                        </div>
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="fio" placeholder="ФИО" required="">
                            </div>
                        </div>
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="email" placeholder="E-mail" required="" pattern="([A-z0-9_.-]{1,})@([A-z0-9_.-]{1,}).([A-z]{2,8})" title="Пример: example@mail.ru">
                            </div>
                        </div>
                        <div class="col-md-40 col-sm-60">
                            <div class="field">
                                <input type="text" name="phone" placeholder="Тел. номер" required="" title="Пример: +7(901)234-56-78">
                            </div>
                        </div>
                        <div class="clearfix"></div>
                        <div class="error alert alert-danger" style="display:none;"></div>
                        <div class="col-md-40 col-md-offset-40 col-sm-60 col-sm-offset-30">
                            <button class="get-offer">Отправить</button>
                        </div>
                        <div class="col-xs-120">
                            <div class="department">или свяжитесь с отделом по работе с партнёрами по номеру <router-link to="#" class="blue">+7 (000) 123-45-67</router-link></div>
                            <div class="small">нажимая на кнопку <span class="uppercase">“ОТПРАВИТЬ”</span> Вы принимаете условия <router-link to="#">Обработки персональных данных</router-link></div>
                        </div>
                        <input type="hidden" name="ajax" value="true">
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="unit">
        <div class="wrapper clearfix">
            <div class="col-md-30 col-sm-60">
                <div class="item">
                    <img src="/static/img/general/item-1.png">
                    <h3>Как агрегаторы автосервисов помогли</h3>
                    <p>По своей сути рыбатекст является альтернативой традиционному lorem ipsum, который вызывает у некторых людей недоумение при попытках прочитать рыбу текст. В отличии от lorem ipsum, текст рыба на русском языке наполнит любой макет непонятным смыслом и придаст неповторимый колорит советских времен</p>
                </div>
            </div>
            <div class="col-md-30 col-sm-60">
                <div class="item">
                    <img src="/static/img/general/item-2.png">
                    <h3>Как агрегаторы автосервисов помогли</h3>
                    <p>По своей сути рыбатекст является альтернативой традиционному lorem ipsum, который вызывает у некторых людей недоумение при попытках прочитать рыбу текст. В отличии от lorem ipsum, текст рыба на русском языке наполнит любой макет непонятным смыслом и придаст неповторимый колорит советских времен</p>
                </div>
            </div>
            <div class="col-md-30 col-sm-60">
                <div class="item">
                    <img src="/static/img/general/item-3.png">
                    <h3>Как агрегаторы автосервисов помогли</h3>
                    <p>По своей сути рыбатекст является альтернативой традиционному lorem ipsum, который вызывает у некторых людей недоумение при попытках прочитать рыбу текст. В отличии от lorem ipsum, текст рыба на русском языке наполнит любой макет непонятным смыслом и придаст неповторимый колорит советских времен</p>
                </div>
            </div>
            <div class="col-md-30 col-sm-60">
                <div class="item">
                    <img src="/static/img/general/item-4.png">
                    <h3>Как агрегаторы автосервисов помогли</h3>
                    <p>По своей сути рыбатекст является альтернативой традиционному lorem ipsum, который вызывает у некторых людей недоумение при попытках прочитать рыбу текст. В отличии от lorem ipsum, текст рыба на русском языке наполнит любой макет непонятным смыслом и придаст неповторимый колорит советских времен</p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'ConnectService'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ConnectService.vue